import type { TenantConfig } from '~~/types/tenant'

export type { TenantConfig } from '~~/types/tenant'

/** Safe no-op used when this dedicated branch has not customized features further. */
export const defaultTenantConfig: TenantConfig = {
  name: '',
  domain: '',
  features: {
    virtualVisit: false,
    blog: false,
    patientPortal: false,
    leadGeneration: false,
    healthRecord: false,
  },
}

export const tenantConfig: TenantConfig = {
  name: 'alirezaashrafi',
  domain: 'dr-alirezaashrafi.ir',
  features: {
    virtualVisit: true,
    blog: true,
    patientPortal: true,
    leadGeneration: true,
    healthRecord: true,
  },
}
